import React from 'react';
import { gsap, Expo } from 'gsap';
import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

import {fromBlogSlugToUrl} from '../../../../utils/slug';

import Gradient from '../../../UiComponents/Gradient/Gradient';
import Filter from '../../../../svg/filter.svg';
import FilterClose from '../../../../svg/filter_close.svg';

const BlogMainScreen = ({ mainData, categoryData }) => {
  const langToggle = useLanguage;
  const [open, setOpen] = React.useState(false);

  const [tl] = React.useState(gsap.timeline({ paused: false }));
  let lineOne = React.useRef(null);
  let lineTwo = React.useRef(null);
  // let lineThree = React.useRef(null);
  let bottomLine = React.useRef(null);
  let gradient = React.useRef(null);

  React.useEffect(() => {
    tl.to(lineOne, 1.5, { y: 0, opacity: 1, ease: Expo.easeOut, delay: 3.5 })
      .to(lineTwo, 1.5, { y: 0, opacity: 1, ease: Expo.easeOut, delay: -1.25 })
      // .to(lineThree, 1.5, {
      //   y: 0,
      //   opacity: 1,
      //   ease: Expo.easeOut,
      //   delay: -1.25,
      // })
      .to(bottomLine, 1.5, {
        y: 0,
        opacity: 1,
        ease: Expo.easeOut,
        delay: -1.25,
      })
      .to(gradient, 2.5, {
        y: 0,
        opacity: 1,
        ease: Expo.easeOut,
        delay: -1.7,
      });
  }, [tl]);

  return (
    <section id="top-section" className="blog-main" data-scroll-section>
      <div className="blog-main__center">
        <h1
          className="blog-main__center-title"
          data-scroll=""
          data-scroll-speed="-1"
          data-scroll-delay="0.05"
        >
          <span
            className="blog-main__center-title__overflow"
            data-scroll=""
            data-scroll-speed="2"
            data-scroll-position="top"
          >
            <span
              className="blog-main__center-title__line"
              ref={(e) => (lineOne = e)}
            >
              {langToggle(mainData.title_01_ua, mainData.title_01_ru)}
            </span>
          </span>
          <span
            className="blog-main__center-title__overflow"
            data-scroll=""
            data-scroll-speed="1.5"
            data-scroll-position="top"
          >
            <span
              className="blog-main__center-title__line"
              ref={(e) => (lineTwo = e)}
            >
              {langToggle(mainData.title_02_ua, mainData.title_02_ru)}
            </span>
          </span>
        </h1>
      </div>
      <div className="categories-wrapper" ref={(e) => (bottomLine = e)}>
        <div className="categories-button__wrapper">
          <button
            className={open ? 'categories-button is-open' : 'categories-button'}
            onClick={(e) => setOpen(!open)}
          >
            <span className="categories-button__title-overflow">
              <span className="categories-button__title">
                {langToggle('Категоії Статей', 'Категории Статей')}
              </span>
            </span>

            <span
              className={
                !open
                  ? 'categories-button__icon is-open'
                  : 'categories-button__icon'
              }
            >
              {!open ? (
                <Filter className="categories-button__icon-open" />
              ) : (
                <FilterClose className="categories-button__icon-close" />
              )}
            </span>
          </button>
        </div>
        <div
          className={
            open ? 'categories-overflow is-open' : 'categories-overflow'
          }
        >
          <ul className="categories">
            <li className="categories-item">
                  <Link to={'/blog/'} className="categories-item__link">
                    <span className="categories-item__link-title__overflow">
                      <span className="categories-item__link-title">
                        {langToggle('Всі статті', 'Все статьи')}
                      </span>
                    </span>
                  </Link>
              </li>
            {categoryData.map((item, index) => {
              return (
                <li className="categories-item" key={index}>
                  <Link to={fromBlogSlugToUrl(item.slug)} className="categories-item__link">
                    <span className="categories-item__link-title__overflow">
                      <span className="categories-item__link-title">
                        {langToggle(item.title_ua, item.title_ru)}
                      </span>
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <div
        className="blog-gradient__wrapper"
        data-scroll=""
        data-scroll-speed="2.5"
        data-scroll-delay="0.05"
      >
        <div
          className="blog-gradient__wrapper-owerflow"
          ref={(e) => (gradient = e)}
        >
          <Gradient />
        </div>
      </div>
    </section>
  );
};

BlogMainScreen.propTypes = {
  mainData: PropTypes.object,
};

export default BlogMainScreen;
